/* eslint-disable */
import cgtAxios from "../cgt-axios";
import cgtConfig from "../cgt-config";

class CGTOrderService {
  appVersion=cgtConfig.appVersion;
  apiURL=cgtConfig.apiURL;
  


  async getNewOrders() {
    const axiosConnect = cgtAxios(this.apiURL);
    var token=JSON.parse(localStorage.getItem(cgtConfig.defAUTHUSERTAG));
    return await axiosConnect.post(`/orders/listnew.php`, { ver:this.appVersion, ca:token });
  }  

  async getCanceledOrders() {
    const axiosConnect = cgtAxios(this.apiURL);
    var token=JSON.parse(localStorage.getItem(cgtConfig.defAUTHUSERTAG));
    return await axiosConnect.post(`/orders/listcanceled.php`, { ver:this.appVersion, ca:token });
  }  

  async getCompletedOrders() {
    const axiosConnect = cgtAxios(this.apiURL);
    var token=JSON.parse(localStorage.getItem(cgtConfig.defAUTHUSERTAG));
    return await axiosConnect.post(`/orders/listcompleted.php`, { ver:this.appVersion, ca:token });
  }  

  async processOrder(id) {
    const axiosConnect = cgtAxios(this.apiURL);
    var token=JSON.parse(localStorage.getItem(cgtConfig.defAUTHUSERTAG));
    return await axiosConnect.post(`/orders/process.php`, { ver:this.appVersion, ca:token,id: id });
  }  

  async markAsPaid(id) {
    const axiosConnect = cgtAxios(this.apiURL);
    var token=JSON.parse(localStorage.getItem(cgtConfig.defAUTHUSERTAG));
    return await axiosConnect.post(`/orders/paid.php`, { ver:this.appVersion, ca:token,id: id });
  }  
  async markAsCanceled(id) {
    const axiosConnect = cgtAxios(this.apiURL);
    var token=JSON.parse(localStorage.getItem(cgtConfig.defAUTHUSERTAG));
    return await axiosConnect.post(`/orders/canceled.php`, { ver:this.appVersion, ca:token,id: id });
  }  
  async removeCanceledMark(id) {
    const axiosConnect = cgtAxios(this.apiURL);
    var token=JSON.parse(localStorage.getItem(cgtConfig.defAUTHUSERTAG));
    return await axiosConnect.post(`/orders/rcanceled.php`, { ver:this.appVersion, ca:token,id: id });
  }  



/*
  get(id) {
    return http.post(`/view/product.php`,{ pId: id });
  }

  newCustomer(dataForm) {
    return http.post(`/view/register.php`,dataForm);
  }
*/
  getAllBayi() {
    var token=JSON.parse(localStorage.getItem(cgtConfig.defAUTHUSERTAG));
    const axiosConnect = cgtAxios(cgtConfig.apiURL);
    return axiosConnect.post(`/view/categories.php`,{ ca: token, ver:this.appVersion });
  }

  getAllUser() {
    var token=JSON.parse(localStorage.getItem(cgtConfig.defAUTHUSERTAG));
    const axiosConnect = cgtAxios(cgtConfig.apiURL);
    return axiosConnect.post(`/view/categories.php`,{ ca: token, ver:this.appVersion });
  }

/*
  create(data) {
    return http.post("/tutorials", data);
  }

  update(id, data) {
    return http.put(`/tutorials/${id}`, data);
  }

  delete(id) {
    return http.delete(`/tutorials/${id}`);
  }

  deleteAll() {
    return http.delete(`/tutorials`);
  }

  findByTitle(title) {
    return http.get(`/tutorials?title=${title}`);
  }
  */
}

export default new CGTOrderService();

